var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-width"},[_c('notice',[_vm._v("\n\t\tThis is a test notice. Use this if you want to draw attention, but subtly, to important information.\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }